export default __webpack_public_path__ + "static/media/Google-Pay-Color.e822f6f2.svg";